import { Form, Modal, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { StateModalDTO } from "./state-modal.dto";

interface PrepaidStateModalProps {
    options? : Record<string, string> | undefined;
    open: boolean;
    onCancel: () => void;
    onCreate?: (state: StateModalDTO) => void;
    loading: boolean;
  }
  
const StateModal: React.FC<PrepaidStateModalProps> = ({options, open, onCancel, onCreate, loading }) => {
const [form] = Form.useForm();

return (
    <Modal
        open={open}
        title={'Cambiar estado'}
        okText={'Guardar'}
        cancelText="Cancelar"
        confirmLoading={loading}
        onCancel={() => {
          form.resetFields();
          onCancel()
       }}
       onOk={() => {
         form
           .validateFields()
           .then((values) => {
             form.resetFields();
             onCreate(values);
           })
           .catch((info) => {
             console.error('Validate Failed:', info);
           });
       }}
    >
        <Form<StateModalDTO>
            form={form}
            name="basic"
            layout="vertical"
            autoComplete="off"    
            preserve={false}
        >
            <Form.Item<StateModalDTO>
                label="Estado"
                name="state"
                rules={[{ required: true, message: 'Por favor seleccione un estado.', max: 50 }]}
            >
            
            <Select
                placeholder="Seleccionar estado"
                showSearch
                options={Object.entries(options).map(([key, value]) => ({ label: key, value: value }))}
            />
            </Form.Item>

            <Form.Item<StateModalDTO>
                        label="Observacion"
                        name="observation"
                      >

                    <TextArea
                        placeholder="Observacion" 
                        autoSize={{ minRows: 3 , maxRows: 6 }}
                    />
            </Form.Item>
        </Form>   
    </Modal>
)}



export default StateModal